import React from 'react';
import { withTranslation } from 'react-i18next';
import { Form, Grid } from 'semantic-ui-react';
import { Formik } from 'formik';
import OverviewTable from '../../Filtering/OverviewTable/OverviewTable';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import FiltersPanel from '../../Filtering/FiltersPanel/FiltersPanel';
import ViewOptionsContainer from '../../Inventory/InventoryOverview/ViewOptionsPanel/ViewOptionsContainer';

const ChemicalProductOverviewForm = ({
  dataViewList,
  handleAddNewProductClick,
  renderRowComparator
}) => (
  <Form id="chemicalProductOverviewForm" className="smallScreenReducePaddingOverview">
    <Grid stackable>
      <Grid.Row style={{ paddingTop: '5px' }}>
        <Grid.Column className="componentWithBottomMarginNoPadding">
          <AccordionWrapper
            accordionTitle={'filter.panel.title'}
            className="filterPanel"
            render={() => <FiltersPanel />}
          />
        </Grid.Column>
      </Grid.Row>
      {dataViewList.length > 0 ? (
        <Grid.Row className="componentWithBottomMarginNoPadding">
          <Grid.Column style={{ padding: '0px' }}>
            <Formik
              render={formikProps => (
                <ViewOptionsContainer
                  formikProps={formikProps}
                  dataViewList={dataViewList}
                  handleAddNewRecord={handleAddNewProductClick}
                />
              )}
            />
          </Grid.Column>
        </Grid.Row>
      ) : null}
      <Grid.Row className="componentWithBottomMarginNoPadding">
        <Grid.Column style={{ padding: '0px' }}>
          <OverviewTable
            id="chemicalProductTable"
            clearColumnsDefaultValues={['GEN_TRADE_NAME']}
            renderRowComparator={renderRowComparator}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Form>
);

export default withTranslation()(ChemicalProductOverviewForm);
